<template>
  <v-menu offset-y v-if="notificaciones.length > 0">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" @click="DesactivarTodas">
        <v-badge overlap color="red" :content="cantidad" :value="cantidad">
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list>
      <v-subheader>Notificaciones</v-subheader>
      <v-list-item-group color="primary">
        <v-list-item v-for="notificacion in notificaciones" :key="notificacion.id">
          <v-list-item-icon>
            <v-icon>{{ notificacion.icono }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ notificacion.titulo }}</v-list-item-title>
            <v-list-item-subtitle>{{ notificacion.descripcion }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import NotificacionService from "../../services/Notificacion.service";

export default {
  data() {
    return {
      notificaciones: [],
      cantidad: 0,
    };
  },
  methods: {
    ObtenerActivas() {
      NotificacionService.ObtenerActivas().then((res) => {
        this.notificaciones = res.data;
        this.cantidad = res.data.length;
      });
    },
    DesactivarTodas() {
      NotificacionService.DesactivarTodas().then((res) => {
        this.cantidad = 0;
      });
    },
  },
  mounted() {
    //this.ObtenerActivas();
  },
};
</script>

<style>
</style>